import { Box, Typography } from "@bca/ui-library";

import CloseButton from "../CloseButton";
import VrmSearchInput from "../VrmSearchInput";

interface HeaderProps {
  onCloseModal: () => void;
  isScrolledToTop: boolean;
  modalVrmQuery: string;
  setModalVrmQuery: (vrmQuery: string) => void;
  shouldShowVrmQueryWarning: boolean;
  onShowVehicles: () => void;
}

const Header: React.FunctionComponent<HeaderProps> = ({
  onCloseModal,
  isScrolledToTop,
  modalVrmQuery,
  setModalVrmQuery,
  shouldShowVrmQueryWarning,
  onShowVehicles,
}) => {
  const onEnter = () => {
    if (!shouldShowVrmQueryWarning) {
      onShowVehicles();
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      px={5}
      css={`
        box-shadow: ${!isScrolledToTop
          ? "0px 3px 5px rgba(218, 218, 218, 0.5);"
          : "none"};
      `}
    >
      <Box width="100%" justifyContent="flex-end" display="flex">
        <CloseButton onClick={onCloseModal} />
      </Box>
      <Typography variant="h4" my={0}>
        Filters
      </Typography>
      <VrmSearchInput
        vrmQuery={modalVrmQuery}
        onChange={setModalVrmQuery}
        warning={shouldShowVrmQueryWarning}
        onEnter={onEnter}
        isMobile
      />
    </Box>
  );
};

export default Header;
